import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpHeaders,
  HttpInterceptorFn,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { LoginService } from 'src/app/features/login/login.service';

export const AuthInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<any> => {
  const loginService = inject(LoginService);
  const router = inject(Router);
  const isAuthenticationRequest = req.url.includes('/authenticate-service/');
  const isLogoutRequest = req.url.includes('/authenticate-service/logout');

  if (
    !environment.MOCK_DATA &&
    loginService.isSessionInvalidated() &&
    !isAuthenticationRequest
  ) {
    return throwError(
      () =>
        new HttpErrorResponse({
          status: HttpStatusCode.Unauthorized,
          statusText: 'Unauthorized',
          url: req.url,
        }),
    );
  }

  const accessToken = loginService.getAccessToken();
  let headers: HttpHeaders = req.headers.set('ngsw-bypass', 'true');

  if (accessToken && !req.headers.has('Authorization')) {
    headers = headers.set('Authorization', `Bearer ${accessToken}`);
  }

  const authReq = req.clone({ headers, withCredentials: true });
  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (environment.MOCK_DATA) {
        return throwError(() => error);
      }

      if (error.status === HttpStatusCode.Unauthorized && !isLogoutRequest) {
        // Invalidate locally first so requests still running in the page cannot
        // continue after the server has rejected the session. logout() is guarded
        // and sends the server-side logout request only once.
        loginService.logout();
      }

      if (error.status === HttpStatusCode.Forbidden) {
        router.navigate(['/help-center/forbidden']);
      }

      return throwError(() => error);
    }),
  );
};
